import axios from "axios";

// Resolve API base URL:
// - If the backend hostname matches the current window hostname (ignoring www.),
//   use same-origin "/api" — this avoids CORS on production domains that serve
//   both frontend and backend from the same host (e.g. www.prmushop.com vs prmushop.com).
// - Otherwise fall back to the configured REACT_APP_BACKEND_URL + "/api".
function _apiBase() {
  const raw = process.env.REACT_APP_BACKEND_URL || "";
  if (typeof window === "undefined") return `${raw}/api`;
  const strip = (h) => (h || "").replace(/^www\./, "");
  try {
    const backendHost = raw ? strip(new URL(raw).hostname) : "";
    const currentHost = strip(window.location.hostname);
    if (backendHost && backendHost === currentHost) return "/api";
  } catch {}
  return `${raw}/api`;
}

export const API = _apiBase();

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function money(cents) {
  if (cents == null) return "—";
  return "$" + (cents / 100).toFixed(2);
}
